/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import DateTimePickerSplitted from '/client/src/components/dateTimePicker/dateTimePickerSplitted';
import { convertToLocalTime, convertToUTC } from '../../../../../utils/jstz';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import moment from 'moment';

type PropsType = {
  index: number,
  sale_begin_time_utc: string,
  sale_end_time_utc: string,
  onChange: (string) => void
};
const endDateValidationMsgRef = React.createRef();

const TicketDates = ({
  index,
  sale_begin_time_utc,
  sale_end_time_utc,
  onChange
}: PropsType): React.Element<'div'> => {
  const eventContext = React.useContext(EventDetailContainerContext);
  const timeZone = eventContext.time_zone_id;

  const validateStartEndDate = (type: string, slaveDate: string): boolean => {
    const parentNode = document.querySelector(`.event-dates_${index}`);

    parentNode.querySelector('.sale_start_time_after_dateValidationMsg').style.display = 'none';
    parentNode.querySelector('.sale_end_time_before_dateValidationMsg').style.display = 'none';

    const masterDate = type === 'sale_begin_time_utc' ? sale_begin_time_utc : sale_end_time_utc;

    const mask = type === 'sale_begin_time_utc' ? moment(masterDate).isAfter(slaveDate) : moment(masterDate).isBefore(slaveDate);

    const el = type === 'sale_begin_time_utc' ?
      parentNode.querySelector('.sale_start_time_after_dateValidationMsg') :
      parentNode.querySelector('.sale_end_time_before_dateValidationMsg');

    if (!mask) {
      el.style.display = 'block';
      console.log('show');
    } else {
      el.style.display = 'none';
      console.log('hide');
    }
  };

  return (
    <div className={`event-dates-wr event-dates_${index}`}>
        <div
          id={`te_startDate-${index}`}
          className="form-group SimpleInput"
          onBlur={(): any => {
            const el = document.querySelector('.date');

            el.parentNode.parentNode.style.zIndex = 9;
          }}
          onFocus={(): any => {
            const el = document.querySelector('.date');

            el.parentNode.parentNode.style.zIndex = 99999;
          }}
        >
          <label>Start ticket sales</label>
              <div
                className="form-group"
                style={{
                  position: 'relative',
                  zIndex: 9
                }}
              >
                <div className="date">
                  <DateTimePickerSplitted
                    id={`te_startDate-${index}`}
                    date={convertToLocalTime(sale_begin_time_utc, timeZone)}
                    cb={(date: string) => {
                      onChange(convertToUTC(date, timeZone), 'sale_begin_time_utc');
                      validateStartEndDate('sale_begin_time_utc', convertToUTC(date, timeZone));
                    }}
                  />
                </div>

                <div
                  className='sale_start_time_after_dateValidationMsg'
                  style={{
                    display: 'none',
                    color: 'red'
                  }}
                >
                  Start date can't be after End date
                </div>
              </div>
      </div>

        <div
          id={`te_endDate-${index}`}
          className="form-group SimpleInput"
          onBlur={(): any => {
            const el = document.querySelector('.e_date');

            el.parentNode.parentNode.style.zIndex = 9;
          }}
          onFocus={(): any => {
            const el = document.querySelector('.e_date');

            el.parentNode.parentNode.style.zIndex = 99999;
          }}
        >
          <label>End ticket sales</label>
            <div className="form-group">
              <div className="date e_date">
                <DateTimePickerSplitted
                  date={convertToLocalTime(sale_end_time_utc, timeZone)}
                  cb={(date: string) => {
                    onChange(convertToUTC(date, timeZone), 'sale_end_time_utc');
                    validateStartEndDate('sale_end_time_utc', convertToUTC(date, timeZone));
                  }}
                />
              </div>

              <div
                className='sale_end_time_before_dateValidationMsg'
                style={{
                  display: 'none',
                  color: 'red'
                }}
              >
                End date can't be before Start date
              </div>
              <div
                ref={endDateValidationMsgRef}
                id={`te_endDateValidationMsg-${index}`}
                style={{
                  display: 'none',
                  color: 'red'
                }}
              >
                End date can't be after the event end date
              </div>
            </div>
      </div>
    </div>
  );
};

export default TicketDates;
